'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AuditView$AuditEntry(id, at, user, email, origin, action, entity, ref, target, added, removed, scope) {
  this.C9 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.C6 = null;
  this.Jm = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$L0;
  this.C7 = null;
  this.wC = null;
  this.C5 = null;
  this.C8 = null;
  this.Ca = null;
  this.wE = null;
  this.tz = null;
  this.tA = null;
  this.wD = null;
  this.C9 = id;
  this.C6 = at;
  this.Jm = user;
  this.C7 = email;
  this.wC = origin;
  this.C5 = action;
  this.C8 = entity;
  this.Ca = ref;
  this.wE = target;
  this.tz = added;
  this.tA = removed;
  this.wD = scope;
}
export { $c_Lpresto_AuditView$AuditEntry as $c_Lpresto_AuditView$AuditEntry };
$p = $c_Lpresto_AuditView$AuditEntry.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AuditView$AuditEntry;
/** @constructor */
function $h_Lpresto_AuditView$AuditEntry() {
}
export { $h_Lpresto_AuditView$AuditEntry as $h_Lpresto_AuditView$AuditEntry };
$h_Lpresto_AuditView$AuditEntry.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_T__hashCode__I("AuditEntry"));
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_1 = acc;
  var t = this.C9;
  acc = $x_2.o($x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t.e, t.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.C6));
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$();
  var $x_3 = acc;
  var t$1 = this.Jm;
  acc = $x_4.o($x_3, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().bj(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_RTLong(t$1.e, t$1.f)));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.C7));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wC));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.C5));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.C8));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.Ca));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wE));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tz));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.tA));
  acc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().o(acc, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().A(this.wD));
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_Statics$().ai(acc, 12);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_AuditView$AuditEntry)) {
    var this$1 = this.C9;
    var b = x$0.C9;
    if (((this$1.e === b.e) && (this$1.f === b.f))) {
      var this$2 = this.Jm;
      var b$1 = x$0.Jm;
      var $x_4 = ((this$2.e === b$1.e) && (this$2.f === b$1.f));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x = this.C6;
      var x$2 = x$0.C6;
      var $x_3 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_3 = false;
    }
    if ((((((($x_3 && (this.C7 === x$0.C7)) && (this.wC === x$0.wC)) && (this.C5 === x$0.C5)) && (this.C8 === x$0.C8)) && (this.Ca === x$0.Ca)) && (this.wE === x$0.wE))) {
      var x$3 = this.tz;
      var x$4 = x$0.tz;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.tA;
      var x$6 = x$0.tA;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$7 = this.wD;
      var x$8 = x$0.wD;
      return ((x$7 === null) ? (x$8 === null) : x$7.i(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 12;
});
$p.s = (function() {
  return "AuditEntry";
});
$p.j = (function(n) {
  switch (n) {
    case 0: {
      return this.C9;
      break;
    }
    case 1: {
      return this.C6;
      break;
    }
    case 2: {
      return this.Jm;
      break;
    }
    case 3: {
      return this.C7;
      break;
    }
    case 4: {
      return this.wC;
      break;
    }
    case 5: {
      return this.C5;
      break;
    }
    case 6: {
      return this.C8;
      break;
    }
    case 7: {
      return this.Ca;
      break;
    }
    case 8: {
      return this.wE;
      break;
    }
    case 9: {
      return this.tz;
      break;
    }
    case 10: {
      return this.tA;
      break;
    }
    case 11: {
      return this.wD;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lpresto_AuditView$AuditEntry(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.hN)));
}
export { $isArrayOf_Lpresto_AuditView$AuditEntry as $isArrayOf_Lpresto_AuditView$AuditEntry };
var $d_Lpresto_AuditView$AuditEntry = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AuditView$AuditEntry, "presto.AuditView$AuditEntry", ({
  hN: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_AuditView$AuditEntry as $d_Lpresto_AuditView$AuditEntry };
//# sourceMappingURL=presto.-Audit-View$-Audit-Entry.js.map
